import { getCategoryHref } from '../../utils/common/category';
import { PAINTING_IDEA_GENERATOR_CATEGORY } from '../../constants';

import { chipValues } from './shared';

const data = [
  {
    type: 'chips',
    properties: {
      isAdvanced: false,
      name: 'paintingIdeaGeneratorType',
      analyticsName: 'painting_idea_type',
      textLabel: 'Generate painting ideas for...',
      hasErrorValidation: false,
      warningMessage: null,
      selectedCategory: PAINTING_IDEA_GENERATOR_CATEGORY,
      required: false,
      flex: '100%',
      information: null,
      chipValues,
      defaultChipValue: {
        title: 'Painting',
        value: getCategoryHref(PAINTING_IDEA_GENERATOR_CATEGORY),
      },
    },
  },
  {
    type: 'input',
    properties: {
      name: 'paintingIdeaGeneratorTopic',
      isAdvanced: false,
      flex: '100%',
      analyticsName: 'painting_ideas_generator',
      placeholder: 'Try "landscape" or "oil painting of city"',
      textLabel: 'Describe what you want to paint',
      hasErrorValidation: true,
      warningMessage: null,
      information: null,
      selectedCategory: PAINTING_IDEA_GENERATOR_CATEGORY,
      required: true,
      tooltipProps: null,
    },
  },
];

export default data;
